import { t } from '@lingui/core/macro'
import { createColumnHelper } from '@tanstack/react-table'
import { Tooltip } from '@tecsinapse/cortex-react'
import React from 'react'
import { FaRegFileAlt } from 'react-icons/fa'
import { GoPerson } from 'react-icons/go'
import { LiaFolderOpenSolid } from 'react-icons/lia'
import { MdOutlineCalendarMonth } from 'react-icons/md'
import { i18n } from '@/i18n'
import { ItemBiblioteca } from '@/core/types/graphql'
import { truncate } from '@/core/utils/truncate'

const columnHelper = createColumnHelper<ItemBiblioteca>()

const mobileColumn = () => {
  return columnHelper.display({
    id: 'mobile-view',
    cell: ({ row: { original: itemBiblioteca } }) => (
      <div className='flex flex-row items-center gap-3'>
        <div className='rounded-mili border items-center overflow-clip flex text-primary-medium'>
          {itemBiblioteca.isPasta ? (
            <LiaFolderOpenSolid size={24} className='m-deca' />
          ) : itemBiblioteca?.arquivoMiniaturaLink ? (
            <img
              src={itemBiblioteca.arquivoMiniaturaLink}
              className='w-[58px] h-[58px] object-cover'
            />
          ) : (
            <FaRegFileAlt size={24} className='m-deca' />
          )}
        </div>
        <div className='flex flex-col'>
          <div className='flex items-center space-x-mili'>
            <Tooltip text={itemBiblioteca.nome}>
              <p className='font-bold text-h5 text-secondary-xdark'>
                {truncate(itemBiblioteca.nome)}
              </p>
            </Tooltip>
          </div>

          <div className='flex items-center space-x-micro'>
            <MdOutlineCalendarMonth className='text-primary-medium' size={16} />
            <p className='text-sub text-secondary-xdark'>
              <span className='font-bold'>{t`Criação:`} </span>
              {i18n.date(itemBiblioteca.dataCriacao, { dateStyle: 'short' })}
            </p>
          </div>

          {itemBiblioteca?.proprietario?.nome && (
            <div className='flex items-center space-x-micro'>
              <GoPerson className='text-primary-medium' />
              <p className='text-sub text-secondary-xdark'>
                <span className='font-bold'>{t`Criado por:`} </span>
                {itemBiblioteca.proprietario.nome}
              </p>
            </div>
          )}
        </div>
      </div>
    )
  })
}

export const columnsArquivos = (props: { isMobile?: boolean }) => {
  const { isMobile } = props

  if (isMobile) {
    return [mobileColumn()]
  }

  return [
    columnHelper.display({
      id: 'nome',
      cell: ({ row: { original: itemBiblioteca } }) => {
        return (
          <div className='flex items-center space-x-mili'>
            <div className='rounded-mili border items-center flex text-primary-medium overflow-clip'>
              {itemBiblioteca.isPasta ? (
                <LiaFolderOpenSolid size={24} className='m-deca' />
              ) : itemBiblioteca?.arquivoMiniaturaLink ? (
                <img
                  src={itemBiblioteca.arquivoMiniaturaLink}
                  className='w-[58px] h-[58px] object-cover'
                  loading='lazy'
                />
              ) : (
                <FaRegFileAlt size={24} className='m-deca' />
              )}
            </div>
            <Tooltip text={itemBiblioteca.nome}>
              <p className='font-bold text-h5 text-secondary-xdark'>
                {truncate(itemBiblioteca.nome)}
              </p>
            </Tooltip>
          </div>
        )
      }
    }),
    columnHelper.display({
      id: 'date',
      cell: ({ row: { original: itemBiblioteca } }) => (
        <div className='flex items-center space-x-micro'>
          <MdOutlineCalendarMonth className='text-primary-medium' size={16} />
          <p className='text-sub text-secondary-xdark'>
            <span className='font-bold'>{t`Criação:`} </span>
            {i18n.date(itemBiblioteca.dataCriacao, { dateStyle: 'short' })}
          </p>
        </div>
      )
    }),
    columnHelper.display({
      id: 'creator',
      cell: ({ row: { original: itemBiblioteca } }) => (
        <div className='flex items-center space-x-micro'>
          <GoPerson className='text-primary-medium' />
          <p className='text-sub text-secondary-xdark'>
            <span className='font-bold'>{t`Criado por:`} </span>
            {itemBiblioteca?.proprietario?.nome || '-'}
          </p>
        </div>
      )
    })
  ]
}
